var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoUroute = function SvgLogoUroute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "UROUTE",
    viewBox: "0 0 150 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.285 22.654 3.39 2.376H9.68L6.577 22.694c-.662 4.406.083 6.375 3.188 6.375 3.104 0 4.428-2.013 5.09-6.331l3.104-20.362h6.002l-3.187 21.002C19.616 30.69 16.14 34.584 9.559 34.584c-8.072.005-10.392-4.66-9.274-11.93ZM34.348 22.268h-2.609l-1.78 11.764h-6.125l4.84-31.656h7.945c6.704 0 10.264 2.824 10.264 8.383 0 4.148-1.158 8.041-6.454 10.269l3.683 13.004h-6.37l-3.394-11.764Zm1.363-4.919c2.732 0 5.051-1.285 5.051-5.945 0-2.482-1.407-3.595-4.428-3.595h-2.359l-1.49 9.54h3.226ZM82.686 22.654 85.79 2.376h6.292l-3.104 20.318c-.662 4.406.083 6.375 3.187 6.375 3.104 0 4.428-2.013 5.09-6.331l3.104-20.362h6.003l-3.188 21.002c-1.157 7.313-4.634 11.206-11.215 11.206-8.072.005-10.391-4.66-9.273-11.93ZM115.425 7.852h-7.077l.829-5.476h20.484l-.868 5.476h-7.077l-4.016 26.18h-6.248l3.973-26.18ZM132.888 2.376h17.09l-.828 5.476h-10.843l-1.074 7.143h7.699l-.785 5.134h-7.699l-1.324 8.554h11.421l-.828 5.349h-17.67l4.841-31.656Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.855 0c-8.743 0-15.828 7.085-15.828 15.828 0 8.742 15.828 29.744 15.828 29.744S80.682 24.57 80.682 15.828C80.682 7.085 73.597 0 64.855 0Zm0 23.991a8.163 8.163 0 0 1-8.164-8.163 8.166 8.166 0 0 1 8.164-8.164 8.163 8.163 0 0 1 8.163 8.164 8.163 8.163 0 0 1-8.163 8.163Z",
    fill: "url(#logo-uroute_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.855 49.912c8.01 0 14.503-1.945 14.503-4.345 0-2.4-6.493-4.345-14.503-4.345S50.35 43.167 50.35 45.567c0 2.4 6.494 4.345 14.504 4.345Z",
    fill: "url(#logo-uroute_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-uroute_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.5033 0 0 4.34567 64.855 45.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#444247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#6E6C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#949396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#B5B4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#D0D0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-uroute_svg__a",
    x1: 49.028,
    y1: 22.785,
    x2: 80.681,
    y2: 22.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#648396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C5CE"
  })))));
};

export default SvgLogoUroute;